import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import newConversationSignature from './newConversationSignature.request';
import { NewConversationResponse, NewConversationResponseError } from './newConvesationSignature.interface';

const useNewConversation = () => {
    return useMutation<
        NewConversationResponse,
        AxiosError<NewConversationResponseError>,
        { id: string; metadata?: Record<string, any> }
    >({
        mutationFn: (variables) => newConversationSignature({ id: variables.id, metadata: variables.metadata || {} }),
    });
};

export default useNewConversation;
